var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-251 -4876)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(251 4876)",
    fill: "none",
    stroke: "#dae028",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(262 4886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.9,80.1V68.84s-.616-2.355-2.8-2.24-2.912.46-3.92,1.666V80.1h-5.6V62.291h5.6v2.643s1.848-3.677,5.6-3.389c3.472.23,6.048,2.413,6.608,7.066h.112V80.1ZM352.86,59.994a3.448,3.448,0,1,1,3.36-3.447A3.414,3.414,0,0,1,352.86,59.994Zm2.8,20.106h-5.6V62.291h5.6Z",
    transform: "translate(-349.5 -53.1)",
    fill: "url(#a)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn2);
export default __webpack_public_path__ + "static/media/LinkedIn_2.5c28acf7ff6fa27d77de7ab8727b67a8.svg";
export { ForwardRef as ReactComponent };